// -- CONST
import { Route } from "v2/api/classes/route";
import { authRoutes } from "./routesGroups/authRoutes";
import { nonAuthRoutes } from "./routesGroups/nonAuthRoutes";

export const getRoutes = (token: boolean): Route<any>[] => {
  let routes: Record<string, Route<any>> = authRoutes;
  if (!token) routes = nonAuthRoutes;
  return Object.values(routes);
};
